import React, { Component } from 'react';
import { connect } from 'react-redux';

// Actions
import {
    fetchHomeDetailMeters,
    fetchDeviceForMeter,
    onDeleteMeter,
    onDeleteDeviceForMeter,
    onUndeleteDeviceForMeter,
    onUndeleteMeter,
    onAddOrEditDeviceModalIsShown,
} from '../../../data/homes/actions';
import { fetchMeterTypes, fetchHubStatus, fetchHubMessages, fetchMeterSupportStatus, changeMeterSupportStatus, deleteHubMessages, postHubMessage, fetchMeterConnectionStatus, triggerMeterSupportUpdate } from '../../../data/meters/actions';
import { fetchAllDeviceTypes } from '../../../data/deviceTypes/actions';

// Selectors
import {
    getHomeDetailMetersData,
    getHomeDetailMetersAreLoading,
    getAddOrEditDeviceModalIsShown,
} from '../../../data/homes/selectors';
import {
    selectedLangageSelector
} from '../../../data/app/selector';

// Components
import { Table, Button, Icon, Row, Col, Layout, Divider, Select, Modal, Spin } from 'antd';
import { strings } from '../../../localization';
import AddOrEditMeterModal from './AddOrEditMeterModal';
import Text from 'antd/es/typography/Text';
import SwitchListScreen from './SwitchListScreen';
import { fetchAllSwitches } from '../../../data/switch/actions';
import HubDetailsModal from './HubDetailsModal';

import { getDisplayLabelForMeterType } from '../../../utils';

const AddMeterButton = ({ onClick }) => (
    <Button
        key="add-detail-meter"
        size="default"
        type="primary"
        onClick={onClick}
        style={{margin: 8 }}
    >
        <Icon type="plus" />
        {strings.homes.detail.addMeterButton}
    </Button>
);

const ButtonGroup = Button.Group;
const timePeriod = 5000;

class SiteConfigTab extends Component {
    state = {
        addOrEditMeterModalIsShown : false,
        deleteModalShown: false,
        deleteModalIsLoading: false,
        isDeletingDevice: false,
        recordToDelete: null,
        siteConfigRecordToEdit: undefined,
        selectedHub: undefined,
        hubStatus: undefined,
        meterCategory: undefined,
        hubMessages: undefined,
        hubDetailsIsShown: false,
        hubDetailsIsLoading: false,
        hubMeterStatus: undefined,
        loadHubStatusTimer: undefined,
        loadHubMessageTimer: undefined,
        loadMeterStatusTimer: undefined,
        loadMeterSupportStatusTimer: undefined,
        meterSupportEnabled: undefined,
        pageIsMounted: true,
    };

    componentWillMount() {
        const { params, fetchHomeDetailMeters, fetchMeterTypes, fetchAllDeviceTypes } = this.props;
        fetchHomeDetailMeters(params);
        fetchMeterTypes();
        fetchAllDeviceTypes();

        this.loadHubStatus(undefined, false);
        this.loadHubMessages(undefined, false);
        this.loadMeterStatus(undefined, false);
        this.loadMeterSupportStatus(undefined, false);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.selectHubMeter(nextProps);
    }

    componentWillUnmount() {
        const {loadHubStatusTimer, loadHubMessageTimer, loadMeterStatusTimer, loadMeterSupportStatusTimer} = this.state;
        this.setState(() => ({ pageIsMounted: false }));

        clearTimeout(loadHubStatusTimer);
        clearTimeout(loadHubMessageTimer);
        clearTimeout(loadMeterSupportStatusTimer);
        clearTimeout(loadMeterStatusTimer);
    }

    storeHubStatus = (manuallyTriggered) => {
        const { pageIsMounted } = this.state;
        if (!manuallyTriggered && pageIsMounted) {
            return (status) => {
                const timer = setTimeout(this.loadHubStatus, timePeriod);
                this.setState(() => ({ loadHubStatusTimer: timer }));
                if (status !== undefined) {
                    this.setState(() => ({ hubStatus: status }));
                }
            }
        }
        return (status) => {
            if (status !== undefined) {
                this.setState(() => ({ hubStatus: status }));
            }
        }
    }

    storeMeterStatus = (manuallyTriggered) => {
        const { pageIsMounted } = this.state;
        if (!manuallyTriggered && pageIsMounted) {
            return (status) => {
                const timer = setTimeout(this.loadMeterStatus, timePeriod);
                this.setState(() => ({ loadMeterStatusTimer: timer }));
                if (status !== undefined) {
                    this.setState(() => ({ hubMeterStatus: status }));
                }
            }
        }
        return (status) => {
            if (status !== undefined) {
                this.setState(() => ({ hubMeterStatus: status }));
            }
        }
    }

    storeHubMessages = (manuallyTriggered) => {
        const { pageIsMounted } = this.state;
        if (!manuallyTriggered && pageIsMounted) {
            return (messages) => {
                const timer = setTimeout(this.loadHubMessages, timePeriod);
                this.setState(() => ({ loadHubMessageTimer: timer }));
                if (messages !== undefined) {
                    this.setState(() => ({ hubMessages: messages }));
                }
            }
        }
        return (messages) => {
            if (messages !== undefined) {
                this.setState(() => ({ hubMessages: messages }));
            }
        }
    }

    storeMeterSupportStatus = (manuallyTriggered) => {
        const { pageIsMounted } = this.state;
        if (!manuallyTriggered && pageIsMounted) {
            return (status) => {
                const timer = setTimeout(this.loadMeterSupportStatus, timePeriod);
                this.setState(() => ({ loadMeterSupportStatusTimer: timer }));
                if (status !== undefined) {
                    this.setState(() => ({ meterSupportEnabled: status }));
                }
            }
        }
        return (status) => {
            if (status !== undefined) {
                this.setState(() => ({ meterSupportEnabled: status }));
            }
        }
    }

    selectHubMeter = (props) => {
        let { selectedHub } = this.state;
        if (selectedHub !== undefined) {
            let found = false;
            // check if it fits to the home
            const hubMeters = this.findHubMeters(props);
            for (const hub in hubMeters) {
                if (selectedHub === hubMeters[hub].meter) {
                    found = true;
                }
            }
            if (!found && hubMeters && hubMeters.length > 0) {
                selectedHub = undefined;
                this.setState(() => ({ selectedHub: undefined }));
            }
        }
        const firstHub = this.findFirstHub(props);
        if (selectedHub === undefined && firstHub !== undefined) {
            const hub = firstHub.meter;
            this.setState(() => ({ selectedHub: hub }));
            selectedHub = hub;
        }
        if (selectedHub !== undefined) {
            this.loadHubStatus(selectedHub, true);
            this.loadHubMessages(selectedHub, true);
            this.loadMeterStatus(selectedHub, true);
            this.loadMeterSupportStatus(selectedHub, true);
            fetchAllSwitches(selectedHub);
        }
    }

    getSelectedHubName = (props) => {
        const { selectedHub } = this.state;

        const hubMeters = this.findHubMeters(props);

        const hubMeter = hubMeters.find(hub => hub.id === selectedHub);

        if (!hubMeter) {
            return undefined;
        } 
        
        return hubMeter.name;        
    }        

    onDeleteModalStateReset = () => {
        this.setState(() => ({
            deleteModalShown: false,
            deleteModalIsLoading: false,
            hubStatus: undefined,
            isDeletingDevice: false,
            recordToDelete: undefined
        }));
    };

    toggleHubDetailsModal = (isShown) => () => {
        this.setState(() => ({
            hubDetailsIsShown: isShown
        }))
    }

    fetchDeviceForMeterIfNeeded = (expanded, record) => {
        if (expanded && !record.deleted) {
            const { fetchDeviceForMeter } = this.props;
            fetchDeviceForMeter(record.meter);
        } else {
            return false;
        }
    };

    toggleAddOrEditMeterModal = (isShown, record, category) => () => {
        if (category && isShown) {
            this.setState({ meterCategory:category });
        } else if (record && isShown) {
            this.setState({ siteConfigRecordToEdit: record, meterCategory:category });
        } else if (!isShown) {
            this.setState({ siteConfigRecordToEdit: undefined });
        }

        this.setState({ addOrEditMeterModalIsShown: isShown });
    };

    onDeleteModalShownToggle = (isShown, meterRecord, deviceRecord) => () => {
        if (deviceRecord) {
            this.setState({
                isDeletingDevice: true,
                recordToDelete: deviceRecord
            });
        } else {
            this.setState({
                isDeletingDevice: false,
                recordToDelete: meterRecord
            });
        }
        this.setState({ deleteModalShown: isShown });
    };

    onDeleteMeterDevice = () => {
        this.setState({ deleteModalIsLoading: true });

        const { recordToDelete, isDeletingDevice } = this.state;
        const {
            params,
            fetchHomeDetailMeters,
            fetchDeviceForMeter,
            onDeleteDeviceForMeter,
            onUndeleteDeviceForMeter,
            onDeleteMeter,
            onUndeleteMeter
        } = this.props;

        if (isDeletingDevice) {
            if (recordToDelete.deleted) {
                onUndeleteDeviceForMeter(recordToDelete.id).then(() => {
                    this.onDeleteModalStateReset();
                    fetchDeviceForMeter(recordToDelete.meterPkey || recordToDelete.meter.id);
                });
            } else {
                onDeleteDeviceForMeter(recordToDelete.id).then(() => {
                    this.onDeleteModalStateReset();
                    fetchDeviceForMeter(recordToDelete.meterPkey || recordToDelete.meter.id);
                });
            }
        } else if (!isDeletingDevice && recordToDelete.deleted) {
            onUndeleteMeter(recordToDelete.id, params).then(() => {
                this.onDeleteModalStateReset();
                fetchHomeDetailMeters(params);
            });
        } else if (!isDeletingDevice && !recordToDelete.deleted) {
            onDeleteMeter(recordToDelete.id, params).then(() => {
                this.onDeleteModalStateReset();
                fetchHomeDetailMeters(params);
            });
        }
    };

    isAllowedToEdit = () => {
        const { isAdmin, isOwnerOfHouse, isInstaller } = this.props;
        return isAdmin || isOwnerOfHouse || isInstaller;
    };

    findMetersForCategory = (category) => {
        const {
            metersDataAreLoading,
            metersData,
        } = this.props;
        const { selectedHub } = this.state;
        if (!metersDataAreLoading && metersData) {
            return metersData.filter(item => (item.category === category && (selectedHub === undefined || item.hubMeterId === selectedHub)));
        }
        return [];
    }

    findHubMeters = (props) => {
        const {
            metersDataAreLoading,
            metersData,
        } = props;
        if (!metersDataAreLoading && metersData) {
            return metersData.filter(item => item.hub && !item.deleted);
        }
        return [];
    }

    findFirstHub = (props) => {
        const hubMeters = this.findHubMeters(props);
        if (hubMeters && hubMeters.length > 0)
            return hubMeters[0];
        return undefined;
    }

    handleSelectHub = (id) => {
        this.setState(() => ({ selectedHub: id, hubStatus: undefined }));
        this.loadHubStatus(id, true);
        this.loadHubMessages(id, true);
        this.loadMeterStatus(id, true);
        this.loadMeterSupportStatus(id, true);
    }

    loadHubStatus = (hub, manuallyTriggered) => {
        const {selectedHub, pageIsMounted} = this.state;
        if (selectedHub !== undefined ||  hub !== undefined) {
            fetchHubStatus(hub !== undefined ? hub : selectedHub, this.storeHubStatus(manuallyTriggered));
        } else if (!manuallyTriggered && pageIsMounted){
            const timer = setTimeout(this.loadHubStatus, timePeriod);
            this.setState(() => ({ loadHubStatusTimer: timer }));
        }
    }

    loadMeterStatus = (hub, manuallyTriggered) => {
        const {selectedHub, pageIsMounted} = this.state;
        if (selectedHub !== undefined ||  hub !== undefined) {
            fetchMeterConnectionStatus(hub !== undefined ? hub : selectedHub, this.storeMeterStatus(manuallyTriggered));
        } else if (!manuallyTriggered && pageIsMounted) {
            const timer = setTimeout(this.loadMeterStatus, timePeriod);
            this.setState(() => ({ loadMeterStatusTimer: timer }));
        }
    }

    loadHubMessages = (hub, manuallyTriggered) => {
        const {selectedHub, pageIsMounted} = this.state;
        if (selectedHub !== undefined ||  hub !== undefined) {
            fetchHubMessages(hub !== undefined ? hub : selectedHub, this.storeHubMessages(manuallyTriggered));
        } else if (!manuallyTriggered && pageIsMounted){
            const timer = setTimeout(this.loadHubMessages, timePeriod);
            this.setState(() => ({ loadHubMessageTimer: timer }));
        }
    }

    loadMeterSupportStatus = (hub, manuallyTriggered) => {
        const {selectedHub, pageIsMounted} = this.state;
        const {isAdmin, isOwnerOfHouse, isInstaller} = this.props;
        if ((selectedHub !== undefined ||  hub !== undefined) && (isAdmin || isOwnerOfHouse || isInstaller)) {
            fetchMeterSupportStatus(hub !== undefined ? hub : selectedHub, this.storeMeterSupportStatus(manuallyTriggered))
        } else if (!manuallyTriggered && pageIsMounted) {
            const timer = setTimeout(this.loadMeterSupportStatus, timePeriod);
            this.setState(() => ({ loadMeterSupportStatusTimer: timer }));
        }
    }

    setMeterSupportStatus = (wantedStatus) => {
        const { selectedHub } = this.state;
        if (selectedHub) {
            let body;
            switch (wantedStatus) {
                case 'on':
                    body = {action: 'ACTIVATE_AUTO_SSH'};
                    break;
                case 'off':
                    body = {action: 'DE_ACTIVATE_AUTO_SSH'};
                    break;
                default:
                    body = {};
            }
            changeMeterSupportStatus(
                selectedHub,
                body,
            )
        }
    }

    triggerUpdate = (target) => {
        const { selectedHub } = this.state;
        if (selectedHub) {
            const body = {action: 'TRIGGER_UPDATE', updateTarget: target};
            triggerMeterSupportUpdate(
                selectedHub,
                body,
            )
        }
    }

    readCompleteConfig = () => {
        const { selectedHub } = this.state;
        if (selectedHub) {
            const body = {action: 'READ_COMPLETE_CONFIG'};
            triggerMeterSupportUpdate(
                selectedHub,
                body,
            )
        }
    }

    reboot = () => {
        const { selectedHub } = this.state;
        if (selectedHub) {
            const body = {action: 'REBOOT'};
            triggerMeterSupportUpdate(
                selectedHub,
                body,
            )
        }
    }


    executeBundledScript = (script) => {
        const { selectedHub } = this.state;
        if (selectedHub) {
            const body = {action: 'EXECUTE_BUNDLED_SCRIPT', parameter: script, executingService: 'WA_METER_SUPPORT'};
            triggerMeterSupportUpdate(
                selectedHub,
                body,
            )
        }
    }

    restartService = (service, executingService) => {
        const { selectedHub } = this.state;
        if (selectedHub) {
            const body = {action: 'RESTART_SERVICE', parameter: service, executingService};
            triggerMeterSupportUpdate(
                selectedHub,
                body,
            )
        }
    }

    writeHubMessage = (hub) => () => {
        const message = {status: "UP", message: "dummy message", ts: Date.now()};

        if (hub !== undefined) {
            postHubMessage(hub, message);
        }
    }

    statusColor = (hubStatus) => {
        if (hubStatus) {
            return (hubStatus.status === "UP" || hubStatus.status === "INFO") ? "green" :
                ( (hubStatus.status === "STARTING" || hubStatus.status === "WARNING") ? "gold" : "red");
        }
        return "grey";
    }

    ageString = (hubStatus) => {
        if (hubStatus) {
            let age = (Date.now() - hubStatus.ts) / 1000;
            if (age < 0)
                age = 0;
            if (age < 60)
                return `${  Math.floor(age)  } sec `;
            age /= 60;
            if (age < 60)
                return `${  Math.floor(age)  } min `;
            age /= 60;
            if (age < 24)
                return `${  Math.floor(age)  } hours `;
            age /= 24;
            return `${  Math.floor(age)  } days `;
        }
        return "";
    }

    afterDelete = () => {
        const {selectedHub} = this.state;

        this.loadHubMessages(selectedHub, true);
        this.setState(() => ({ hubDetailsIsLoading: false }));
    }

    deleteHubMessages = () => {
        this.setState(() => ({ hubDetailsIsLoading: true }));

        const {selectedHub} = this.state;
        if (selectedHub !== undefined){
            deleteHubMessages(selectedHub, this.afterDelete);
        }
    }

    getStatusColor = (meter) => {
        const { hubMeterStatus } = this.state;

        const greenColor = '#1DA57A';
        const redColor = '#FF4D4F';
        const yellowColor = '#FFE607';

        if (hubMeterStatus !== undefined){

            const status = hubMeterStatus.find(meterStatus => meterStatus.meterId === meter.id);

            if (status !== undefined){
                switch(status.status){
                    case 'GREEN':
                        return greenColor;
                    case 'YELLOW':
                        return yellowColor;
                    default:
                        return redColor;
                }
            }

            return redColor;
        }

        return redColor;
    }

    getOnlineSupportStatusText = () => {
        const { meterSupportEnabled } = this.state;

        let statusText;

        switch(meterSupportEnabled) {
            case null:
                statusText = strings.homes.detail.onlineSupportUnknown;
                break;
            case true:
                statusText = strings.homes.detail.onlineSupportActive;
                break;
            case false:
                statusText = strings.homes.detail.onlineSupportNotActive;
                break;
            default:
                statusText = strings.homes.detail.onlineSupportUnknown;
        }

        return `${strings.homes.detail.onlineSupportLabel}: ${statusText}`;
    }

    render() {
        const {
            msgs,
            params,
            isAdmin,
            isOwnerOfHouse,
            isInstaller
        } = this.props;
        const {
            addOrEditMeterModalIsShown,
            siteConfigRecordToEdit,
            selectedHub,
            meterCategory,
            hubStatus,
            recordToDelete,
            deleteModalShown,
            deleteModalIsLoading,
            isDeletingDevice,
            hubMessages,
            hubDetailsIsShown,
            hubDetailsIsLoading,
            meterSupportEnabled,
            pageIsMounted,
        } = this.state;

        const columnsSmall = [
            {
                title: msgs.homes.detail.meterStatus,
                className: 'status-left',
                key: 'status',
                render: (text, record) => (
                    <div style={{display: 'flex', justifyContent: 'center'}}>
                        <div style={ {borderRadius:'50%', backgroundColor:this.getStatusColor(record), width: 12, height: 12}}/>
                    </div>
                )
            },
            {
                title: msgs.homes.detail.meterType,
                className: 'type',
                key: 'type',
                render: (text, record) => (
                    <grid>{getDisplayLabelForMeterType(record.type)}</grid>
                )
            },
            {
                title: msgs.homes.detail.meterName,
                dataIndex: 'name',
                key: 'name',
                width: 120
            },
            {
                title: msgs.actionsLabel,
                className: 'text-right',
                key: 'action',
                render: (text, record) => (
                    <span style={{ float: 'right' }}>
                        {!record.deleted && (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Button
                                    type="primary"
                                    disabled={!this.isAllowedToEdit()}
                                    onClick={this.toggleAddOrEditMeterModal(true, record)}
                                >
                                    <Icon type="edit" />
                                </Button>
                            </ButtonGroup>
                        )}
                        {record.deleted ? (
                            <ButtonGroup>
                                <Button
                                    type="danger"
                                    ghost
                                    onClick={this.onDeleteModalShownToggle(true, record)}
                                >
                                    <Icon type="undo" /> {msgs.undelete}
                                </Button>
                            </ButtonGroup>
                        ) : (
                            <ButtonGroup style={{ marginRight: 10 }}>
                                <Button
                                    type="danger"
                                    disabled={!this.isAllowedToEdit()}
                                    onClick={this.onDeleteModalShownToggle(true, record)}
                                >
                                    <Icon type="delete" />
                                </Button>
                            </ButtonGroup>
                        )}
                    </span>
                )
            }
        ];

        const columnStyle = {
            border: "solid",
            minWidth: "475px"
        }

        const parmsPlusMeter = params;
        parmsPlusMeter.meterId = selectedHub;

        return [
            <div style={{display: 'flex', justifyContent: 'flex-start'}}>
                <div>
                    <Row>
                        {msgs.homes.detail.hub}
                        <Select
                            value={selectedHub}
                            onChange={this.handleSelectHub}
                            type="text"
                            dropdownMatchSelectWidth={false}
                            style={{margin: 8 }}
                        >
                            {this.findHubMeters(this.props).map(meter => (
                                <Select.Option value={meter.meter} key={meter.meter}>
                                    {meter.name}
                                </Select.Option>
                            ))}
                        </Select>
                        {(isAdmin || isOwnerOfHouse || isInstaller) && (
                            <Button
                                key="show-hub-messages"
                                type="default"
                                disabled={!selectedHub}
                                onClick={this.toggleHubDetailsModal(true)}
                                style={{margin: 0 , width: 60}}
                            >
                                <Icon type="message" style={{ fontSize: '120%'}}/>
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="activate-meter-support"
                                size="default"
                                type="primary"
                                onClick={() => this.setMeterSupportStatus('on')}
                                style={{margin: 8 }}
                            >
                                {strings.homes.detail.activateSupport}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="deactivate-meter-support"
                                size="default"
                                type="primary"
                                onClick={() => this.setMeterSupportStatus('off')}
                                style={{marginLeft: 0, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.deactivateSupport}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Text style={{margin: 8 }}>{this.getOnlineSupportStatusText()}</Text>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="trigger-wa-pi-update"
                                size="default"
                                type="primary"
                                onClick={() => this.triggerUpdate('WA_PI')}
                                style={{marginLeft: 0, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerUpdateWaPi}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="trigger-wa-sem-update"
                                size="default"
                                type="primary"
                                onClick={() => this.triggerUpdate('WA_SEM')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerUpdateWaSem}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="trigger-meter-support-update"
                                size="default"
                                type="primary"
                                onClick={() => this.triggerUpdate('WA_METER_SUPPORT')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerUpdateMeterSupport}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="trigger-evcc-update"
                                size="default"
                                type="primary"
                                onClick={() => this.triggerUpdate('EVCC')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerUpdateEvcc}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="read-complete-config"
                                size="default"
                                type="primary"
                                onClick={() => this.readCompleteConfig()}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerReadCompleteConfig}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="reboot"
                                size="default"
                                type="primary"
                                onClick={() => this.reboot()}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerReboot}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="restart-wa-meter-support"
                                size="default"
                                type="primary"
                                onClick={() => this.restartService('wa-meter-support', 'WA_PI')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerRestartWaMeterSupport}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="restart-wa-pi"
                                size="default"
                                type="primary"
                                onClick={() => this.restartService('wa-pi', 'WA_METER_SUPPORT')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerRestartWaPi}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isOwnerOfHouse || isInstaller)) && (
                            <Button
                                key="restart-wa-sem"
                                size="default"
                                type="primary"
                                onClick={() => this.restartService('wa-sem', 'WA_METER_SUPPORT')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerRestartWaSem}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isInstaller)) && (
                            <Button
                                key="install-logrotate"
                                size="default"
                                type="primary"
                                onClick={() => this.executeBundledScript('linux-tools/logrotateSetup.sh -i')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerInstallLogConfigs}
                            </Button>
                        )}
                        {(meterSupportEnabled !== undefined && (isAdmin || isInstaller)) && (
                            <Button
                                key="install-log2ram"
                                size="default"
                                type="primary"
                                onClick={() => this.executeBundledScript('linux-tools/log2ramSetup.sh -i')}
                                style={{marginLeft: 8, marginTop: 8, marginBottom: 8 }}
                            >
                                {strings.homes.detail.triggerInstallLog2Ram}
                            </Button>
                        )}
                        {  /* for manually adding dummy messages for debug purposes
                        <Button
                            key="add-dummy-message"
                            size="default"
                            type="default"
                            onClick={this.writeHubMessage(selectedHub)}
                            style={{marginLeft: 8}}
                        >
                            Add Dummy Message
                            <Icon type="message" style={{ fontSize: '120%'}}/>
                        </Button>
                         */}
                    </Row>
                    <Row>
                        {hubStatus ?
                            (<Col>
                                <Text style={{ color: this.statusColor(hubStatus) }}>{hubStatus.status}</Text>
                                <Text> : </Text>
                                <Text>{this.ageString(hubStatus)}</Text>
                                <Text />
                                <Text>{hubStatus.message}</Text>
                            </Col>)
                            : "" }
                    </Row>
                </div>
            </div>,
            <Layout style={{margin: 8 }}>
                <Row gutter={8}>
                    <Col md={8} style={{...columnStyle, minWidth: '520px', width: '33%'}}>
                        <SwitchListScreen
                            meterId={selectedHub}
                            params={parmsPlusMeter}
                            isAdmin={isAdmin}
                            isOwnerOfHouse={isOwnerOfHouse}
                            isInstaller={isInstaller}
                            pageIsMounted={pageIsMounted}
                            timePeriod={timePeriod}
                        />
                    </Col>
                    <Col md={8} style={{...columnStyle, marginLeft: 1}}>{msgs.homes.detail.production}
                        <AddMeterButton onClick={this.toggleAddOrEditMeterModal(true, undefined, 'Production')}/>
                        <Table
                            pagination={false}
                            dataSource={this.findMetersForCategory('Production')}
                            columns={columnsSmall}
                        />
                    </Col>
                    <Col md={8} style={{...columnStyle, marginLeft: 1}}>{msgs.homes.detail.grid}
                        <AddMeterButton onClick={this.toggleAddOrEditMeterModal(true, undefined, 'Grid')}/>
                        <Table
                            pagination={false}
                            dataSource={this.findMetersForCategory('Grid')}
                            columns={columnsSmall}
                        />
                    </Col>
                </Row>
                <Divider/>
                <Row gutter={12}>
                    <Col md={8} style={{...columnStyle, width: '33%'}}>{msgs.homes.detail.usage}
                        <AddMeterButton onClick={this.toggleAddOrEditMeterModal(true, undefined, 'Usage')}/>
                        <Table
                            pagination={false}
                            dataSource={this.findMetersForCategory('Usage')}
                            columns={columnsSmall}
                        />
                    </Col>
                    <Col md={8} style={{...columnStyle, marginLeft: 1}}>{msgs.homes.detail.storage}
                        <AddMeterButton onClick={this.toggleAddOrEditMeterModal(true, undefined, 'Storage')}/>
                        <Table
                            pagination={false}
                            dataSource={this.findMetersForCategory('Storage')}
                            columns={columnsSmall}
                        />
                    </Col>
                </Row>
            </Layout>,
            addOrEditMeterModalIsShown && (
                <AddOrEditMeterModal
                    key="add-or-edit-meter-modal"
                    msgs={msgs}
                    onCancel={this.toggleAddOrEditMeterModal(false)}
                    onAfterSubmit={this.toggleAddOrEditMeterModal(false)}
                    recordToEdit={siteConfigRecordToEdit}
                    params={params}
                    isShown={addOrEditMeterModalIsShown}
                    category={meterCategory}
                    hubMeterId={selectedHub}
                />
            ),
            recordToDelete && (
                <Modal
                    key="delete-user-modal"
                    visible={deleteModalShown}
                    onCancel={this.onDeleteModalStateReset}
                    onOk={this.onDeleteMeterDevice}
                    okText={recordToDelete.deleted ? msgs.undelete : msgs.delete}
                    okType={recordToDelete.deleted ? 'primary' : 'danger'}
                    confirmLoading={deleteModalIsLoading}
                    cancelText={msgs.close}
                    title={
                        isDeletingDevice
                            ? recordToDelete.deleted
                                ? msgs.sureToUndeleteTitle
                                : msgs.homes.detail.deleteDeviceModalTitle
                            : recordToDelete.deleted
                                ? msgs.sureToUndeleteTitle
                                : msgs.homes.detail.deleteMeterModalTitle
                    }
                >
                    <Spin spinning={deleteModalIsLoading} size="large">
                        <div>
                            <p>
                                {isDeletingDevice
                                    ? msgs.homes.detail.deleteDeviceConfirmDescription[0]
                                    : msgs.homes.detail.deleteMeterConfirmDescription[0]}{' '}
                                <strong>{recordToDelete.name}</strong>
                                &nbsp;
                                {recordToDelete.deleted
                                    ? msgs.homes.detail.undeleteDeviceOrMeter
                                    : msgs.homes.detail.deleteMeterConfirmDescription[1]}
                            </p>
                        </div>
                    </Spin>
                </Modal>
            ),
            hubDetailsIsShown &&
            <HubDetailsModal
                isShown={hubDetailsIsShown}
                isLoading={hubDetailsIsLoading}
                msgs={msgs}
                onCancel={this.toggleHubDetailsModal(false)}
                messages={hubMessages}
                hubName={this.getSelectedHubName(this.props)}
                onDelete={this.deleteHubMessages}
            />
        ];
    }
}

export default connect(
    (state, ownProps) => ({
        ...ownProps,
        metersData: getHomeDetailMetersData(state),
        metersDataAreLoading: getHomeDetailMetersAreLoading(state),
        addOrEditDeviceModalIsShown: getAddOrEditDeviceModalIsShown(state),
        lang: selectedLangageSelector(state)
    }),
    {
        fetchHomeDetailMeters,
        fetchDeviceForMeter,
        fetchMeterTypes,
        onDeleteMeter,
        onUndeleteDeviceForMeter,
        onUndeleteMeter,
        onDeleteDeviceForMeter,
        onAddOrEditDeviceModalIsShown,
        fetchAllSwitches,
        fetchAllDeviceTypes,
        fetchHubStatus,
        fetchHubMessages,
        deleteHubMessages,
        postHubMessage,
        fetchMeterConnectionStatus,
        fetchMeterSupportStatus,
    }
)(SiteConfigTab);
